// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2RS1N","col":"Table_col__133rS","fulfillmentStatus":"Table_fulfillmentStatus__934TR","emailCol":"Table_emailCol__2TAFt"};